<template>
  <div>
    <v-layout>
      <v-flex>
        <TermsAndConditions />
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import TermsAndConditions from "./../TermsAndConditions/TermsAndConditions";
export default {
  components: {
    TermsAndConditions
  },
  data() {
    return {};
  }
};
</script>